import { render, staticRenderFns } from "./BuildingActivityAreaCard.vue?vue&type=template&id=e7c8a808"
import script from "./BuildingActivityAreaCard.vue?vue&type=script&lang=js"
export * from "./BuildingActivityAreaCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports